<template>
	<div class="flow-cloud-source-card" :selected="selected" @click="handleClick($event)">
		<div class="flow-cloud-source-card-header">
			<slot name="header" />
		</div>
		<div class="flow-cloud-source-card-content">
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "CloudSourceCard",
	props: {
		/**
		 * true | false
		 */
		selected: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.flow-cloud-source-card {
	display: flex;
	flex-direction: column;
	border-radius: 8px;
	background-color: var(--slideout-element-light);
	cursor: pointer;
	// max-width: 350px;

	div.flow-cloud-source-card-header {
		border-bottom: 1px solid var(--slideout-border-light);
		padding: 8px 8px 8px 0px;
		display: flex;
		> div.slab-hierarchy
			> div.slab-container
			> div.slab-content
			> div.slab-title
			> span.slab-title-wrapper {
			> p.paragraph-1 {
				line-height: 14px;
			}
			> p.paragraph-3 {
				line-height: 10px;
			}
		}
	}

	div.flow-cloud-source-card-content {
		padding: 16px;

		> p.paragraph-2 {
			line-height: 12px !important;
		}
		> p.paragraph-2 + p.paragraph-2 {
			margin-top: 8px;
		}
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}

	&:focus:not([selected]) {
		box-shadow: 0 0 0 1px var(--slideout-primary);
		outline: none;
	}

	&:before {
		position: absolute;
		top: 0px;
		bottom: 0px;
		left: 0px;
		right: 0px;
		border-radius: 8px;
		background-color: var(--dashboard-success-light);
		// z-index: 1;
		opacity: 1;
		transition: opacity 0.3s linear;
	}

	&[selected] {
		position: relative;
		box-shadow: 0 0 0 1px var(--slideout-success);
		outline: none;
		// z-index: 2;
		&:before {
			content: "";
			opacity: 0.2;
		}
	}
}

div.flow-cloud-source-card-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
	grid-gap: 8px;
}

div.flow-cloud-source-card-grid + div.flow-cloud-source-card-grid {
	margin-top: 8px;
}
</style>
